AOS.init();

document.addEventListener('DOMContentLoaded', function () {
  function animateHeroElements() {
    // Check if required elements exist
    const heroElements = {
      labels: document.querySelectorAll('[gsap-element="hero-label"], [gsap-element="hero-slogan"]'),
      image: document.querySelector('[gsap-element="hero-image"]'),
      parallax: document.querySelector('[gsap-element="hero-parallax"]'),
      parallaxDiv: document.querySelector('[gsap-element="parallax-div"]')
    };

    // Only run animations if elements exist
    if (heroElements.labels.length > 0) {
      gsap.set(heroElements.labels, { opacity: 0 });
      gsap.to(heroElements.labels, {
        opacity: 1,
        duration: 1,
        stagger: 0.3,
        ease: "power2.out"
      });
    }

    if (heroElements.image) {
      gsap.set(heroElements.image, { scale: 1.2 });
      gsap.to(heroElements.image, {
        scale: 1,
        duration: 0.5,
        ease: "power2.out"
      });
    }

    if (heroElements.parallax) {
      gsap.to(heroElements.parallax, {
        yPercent: -10,
        scrollTrigger: {
          trigger: heroElements.parallax,
          start: "top bottom",
          end: "bottom top",
          scrub: true
        }
      });
    }

    if (heroElements.parallaxDiv) {
      gsap.to(heroElements.parallaxDiv, {
        yPercent: -50,
        scrollTrigger: {
          trigger: heroElements.parallaxDiv,
          start: "top bottom",
          end: "bottom top",
          scrub: true
        }
      });
    }
  }

  // Run animations when loader completes
  document.addEventListener("loaderComplete", animateHeroElements);

  // Run animations if page is already loaded
  if (document.readyState === "complete") {
    animateHeroElements();
  }
});



// testimonial-slider js
const testSlider = $('.testimonial-main-slider');
if(testSlider){
$('.testimonial-main-slider').slick({
  infinite: true,
  slidesToShow: 1,
  fade: true,
  cssEase: 'linear',
  arrows:true
});
}




$(document).ready(function() {
const productWrapper = $('.custom-product-main-wrapper');
if (productWrapper.length) { 
  gsap.registerPlugin(ScrollTrigger);

  const $wrapper = $(".product-slider-wrapper");
  const $slides = $(".custom-product-slide");
  
  let totalSlides = $slides.length;

  // Function to calculate the total height of slides
  function calculateTotalHeight() {
    let totalHeight = 0;
    $slides.each(function() {
      totalHeight += $(this).outerHeight();
    });
    return totalHeight; 
  }

  // Function to initialize the slider with GSAP animations
  function initSlider() {
    totalSlides = $slides.length; // Recalculate the number of slides when initializing
    const totalHeight = calculateTotalHeight(); // Ensure we get the latest total height
    const sections = gsap.utils.toArray(".custom-product-slide");

    // Apply GSAP animation
    gsap.to(sections, {
      xPercent: -100 * (totalSlides - 1),
      ease: "none",
      scrollTrigger: {
        trigger: $wrapper[0],
        pin: true,
        scrub: 1,
        snap: 1 / (sections.length - 1),
        end: () => "+=" + $wrapper[0].offsetWidth, // Correct calculation of end position
      }
    });
  }

  // Function to remove GSAP and ScrollTrigger if width is less than or equal to 768px
  function destroySlider() {
    // Kill all ScrollTriggers related to product slider when window width is <= 768px
    ScrollTrigger.getAll().forEach(trigger => {
      if (trigger.trigger && trigger.trigger.matches('.product-slider-wrapper')) {
        trigger.kill();
      }
    });
    // Optionally reset styles applied by GSAP
    $wrapper.css({
      transform: 'none',  // Reset any GSAP transform
      willChange: 'auto', // Reset will-change property
    });
  }

  // Function to check the window width and initialize or kill the ScrollTrigger accordingly
  function checkWidth() {
    if ($(window).width() > 768) {
      initSlider(); // Apply GSAP-based slider if width is greater than 768px
    } else {
      destroySlider(); // Remove GSAP-based slider if width is less than or equal to 768px
    }
  }

  // Initial check and setup
  checkWidth();

  // Re-run the check on window resize
  $(window).resize(() => {
    checkWidth();
    totalSlides = $slides.length; // Update total slides on resize as well
  });
}



 // Initialize split text
let split = new SplitText(".custom-animated-richtext p", { 
  type: "chars",
  position: "relative"
});

// Create timeline with scroll trigger
let tl = gsap.timeline({
  scrollTrigger: {
    trigger: ".custom-animated-richtext",
    start: "top 60%",
    end: "bottom 20%",
    scrub: 1,
  }
});

// Animate characters and images
tl.from(split.chars, {
  opacity: 0.1,
  duration: 1,
  ease: "power2.out",
  stagger: 0.05
})
tl.from(".animated-images-container .animated-main-img", {
  y: 100,
  duration: 1,
  ease: "power2.out",
  stagger: 0.1
}, "-=0.5");

// Handle cleanup if needed
function cleanup() {
  split.revert();
  ScrollTrigger.getAll().forEach(st => st.kill());
}

    });



// accordion
   // detail tag smooth transition
         class Accordion {
          constructor(el) {
            // Store the <details> element
            this.el = el;
            // Store the <summary> element
            this.summary = el.querySelector('summary');
            // Store the <div class="content"> element, but ensure it exists
            this.content = el.querySelector('.accordion__content');
        
            // Ensure content element is found
            if (!this.content) {
              return;
            }
        
            // Store the animation object (so we can cancel it if needed)
            this.animation = null;
            // Store if the element is closing
            this.isClosing = false;
            // Store if the element is expanding
            this.isExpanding = false;
            // Detect user clicks on the summary element
            this.summary.addEventListener('click', (e) => this.onClick(e));
          }
        
          onClick(e) {
            // Stop default behaviour from the browser
            e.preventDefault();
            // Add an overflow on the <details> to avoid content overflowing
            this.el.style.overflow = 'hidden';
            // Check if the element is being closed or is already closed
            if (this.isClosing || !this.el.open) {
              this.open();
            // Check if the element is being opened or is already open
            } else if (this.isExpanding || this.el.open) {
              this.shrink();
            }
          }
        
          shrink() {
            // Set the element as "being closed"
            this.isClosing = true;
            
            // Store the current height of the element
            const startHeight = `${this.el.offsetHeight}px`;
            // Calculate the height of the summary
            const endHeight = `${this.summary.offsetHeight}px`;
            
            // If there is already an animation running
            if (this.animation) {
              // Cancel the current animation
              this.animation.cancel();
            }
            
            // Start a WAAPI animation
            this.animation = this.el.animate({
              // Set the keyframes from the startHeight to endHeight
              height: [startHeight, endHeight]
            }, {
              duration: 400,
              easing: 'ease-out'
            });
            
            // When the animation is complete, call onAnimationFinish()
            this.animation.onfinish = () => this.onAnimationFinish(false);
            // If the animation is cancelled, isClosing variable is set to false
            this.animation.oncancel = () => this.isClosing = false;
          }
        
          open() {
            // Apply a fixed height on the element
            this.el.style.height = `${this.el.offsetHeight}px`;
            // Force the [open] attribute on the details element
            this.el.open = true;
            // Wait for the next frame to call the expand function
            window.requestAnimationFrame(() => this.expand());
          }
        
          expand() {
            // Set the element as "being expanding"
            this.isExpanding = true;
            
            // Ensure content exists before proceeding
            if (!this.content) return;
        
            // Get the current fixed height of the element
            const startHeight = `${this.el.offsetHeight}px`;
            // Calculate the open height of the element (summary height + content height)
            const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
            
            // If there is already an animation running
            if (this.animation) {
              // Cancel the current animation
              this.animation.cancel();
            }
            
            // Start a WAAPI animation
            this.animation = this.el.animate({
              // Set the keyframes from the startHeight to endHeight
              height: [startHeight, endHeight]
            }, {
              duration: 400,
              easing: 'ease-out'
            });
            
            // When the animation is complete, call onAnimationFinish()
            this.animation.onfinish = () => this.onAnimationFinish(true);
            // If the animation is cancelled, isExpanding variable is set to false
            this.animation.oncancel = () => this.isExpanding = false;
          }
        
          onAnimationFinish(open) {
            // Set the open attribute based on the parameter
            this.el.open = open;
            // Clear the stored animation
            this.animation = null;
            // Reset isClosing & isExpanding
            this.isClosing = false;
            this.isExpanding = false;
            // Remove the overflow hidden and the fixed height
            this.el.style.height = this.el.style.overflow = '';
          }
        }
        
        // Initialize all the accordions on the page
        document.querySelectorAll('details').forEach((el) => {
          new Accordion(el);
        });







